import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import FormLayout from '@/components/Form/components/FormLayout';
import { GroupTypeEnum } from '@/types/schema';

import AddCondition from './components/AddCondition';
import { AddedConditionProps } from './components/AddedCondition';
import AddedConditionGroups from './components/AddedConditionGroups';
import { FilterItemProps } from './components/FilterItem';
import useConditions from './hooks/useConditions';
import { ConditionalFieldsMapping, FilterGroupInput } from './types';

export interface ConditionsProps {
  error?: boolean;
  className?: string;
  title?: string;
  description?: string;
  optional?: boolean;
  classes?: {
    addedConditionClasses?: AddedConditionProps['classes'];
    addConditionClassName?: string;
  };
  filterGroup: FilterGroupInput;
  onChange: (filterGroup: FilterGroupInput) => void;
  type: GroupTypeEnum;
  hideTitle?: boolean;
  hideDescription?: boolean;
  RenderFilterItem?: (params: FilterItemProps) => React.JSX.Element;
  fieldsMapping?: ConditionalFieldsMapping[];
  showPlaceholderIcon?: boolean;
  order?: number;
}

function Conditions(props: ConditionsProps) {
  const { t } = useTranslation('Group');
  const {
    className,
    filterGroup,
    error,
    type,
    onChange,
    classes,
    description,
    title,
    optional = true,
    hideTitle,
    hideDescription,
    RenderFilterItem,
    fieldsMapping,
    showPlaceholderIcon,
    order,
  } = props;
  const { methods, data } = useConditions({ setCondition: onChange, filterGroup });
  const { groupsWithTempId } = data;
  const {
    onAddConditionGroup,
    onGroupChange,
    onConditionOperatorChange,
    onGroupDelete,
    onGroupDuplicate,
  } = methods;

  return (
    <FormLayout className={className}>
      {!hideTitle ? (
        <FormLayout.Title optional={optional}>
          {title ?? t('Group:Editor.Condition')}
        </FormLayout.Title>
      ) : null}
      {!hideDescription ? (
        <FormLayout.Description>
          {description ?? type === GroupTypeEnum.UserCollection
            ? t('Group:Editor.ConditionDescription')
            : t('Group:Editor.CollectionConditionDescription')}
        </FormLayout.Description>
      ) : null}
      {/* performance bottleneck fix this @iamsaumya */}
      <AddedConditionGroups
        RenderFilterItem={RenderFilterItem}
        classes={classes?.addedConditionClasses}
        conditionOperator={filterGroup.operator}
        error={error}
        fieldsMapping={fieldsMapping}
        filters={groupsWithTempId}
        order={order}
        showPlaceholderIcon={showPlaceholderIcon}
        type={type}
        onConditionOperatorChange={onConditionOperatorChange}
        onGroupChange={onGroupChange}
        onGroupDelete={onGroupDelete}
        onGroupDuplicate={onGroupDuplicate}
      />
      <AddCondition className={classes?.addConditionClassName} onClick={onAddConditionGroup} />
    </FormLayout>
  );
}

export default React.memo(Conditions);
